import { useMemo } from 'react';
import { IConfigData } from '../../../components/PageContainer/type';

interface IClientFilterConfig {
  searchKey: string;
  searchFields: string[];
}

/**
 * 前端搜索过滤 hook
 * 从 dataProps[searchKey] 读取关键词，对 data 列表做大小写不敏感子串匹配。
 * 当 clientFilter 未传时，直接透传原始 data，不做任何处理。
 */
export function useClientFilter(
  clientFilter: IClientFilterConfig | undefined,
  dataProps: IConfigData | undefined,
  data: unknown,
) {
  const clientSearchKeyword = clientFilter?.searchKey
    ? String(dataProps?.[clientFilter.searchKey] ?? '')
    : '';

  const clientFilteredData = useMemo(() => {
    if (!clientFilter || !clientSearchKeyword.trim()) return data as Record<string, unknown>[];
    const lowerKeyword = clientSearchKeyword.trim().toLowerCase();
    return (data as Record<string, unknown>[])?.filter((row) =>
      clientFilter.searchFields.some((field) =>
        String(row?.[field] ?? '').toLowerCase().includes(lowerKeyword)
      )
    );
  }, [data, clientSearchKeyword, clientFilter]);

  const activeData = clientFilter ? clientFilteredData : data;
  const clientFilteredCount = clientFilter ? clientFilteredData?.length : undefined;

  return { activeData, clientFilteredCount };
}
